import { Pipe, PipeTransform } from '@angular/core';
import { FormComponentForPdf } from '@core/typings/pdf.typing';
import { ReferenceFieldsUI } from '@core/typings/ui/reference-fields.typing';
import { FormDefinitionComponent } from '@features/configure-forms/form.typing';
import { FormHelperService } from '@features/forms/services/form-helper/form-helper.service';

@Pipe({
    name: 'gcMapComponentForPDF',
    standalone: false
})
export class MapComponentForPDFPipe implements PipeTransform {

  constructor (
    private formHelperService: FormHelperService
  ) { }

  transform (
    value: FormDefinitionComponent,
    refFields: ReferenceFieldsUI.RefResponseMap
  ): FormComponentForPdf {
    return this.formHelperService.mapComponentToComponentForPDF(value, refFields);
  }
}
